<template>
  <div class="second-pay-container">
    <div class="title f_c_s">大医健康为您提供高品质服务</div>
    <div class="doctor-info" v-if="order_detail">
      <div class="doctor-detail f_s_s">
        <img :src="order_detail.avatar" alt="" />
        <div class="doctor-detail-right">
          <div class="doctor-name font-85">{{ order_detail.docname }}</div>
          <div class="doctor-job">
            {{ order_detail.position }}{{ order_detail.hospitalname }}
          </div>
          <div class="f_s_s" style="height: 1rem; margin-bottom: 1rem">
            <div
              class="doctor-tag"
              v-for="(item, index) in order_detail.label_list"
              :key="index"
              v-show="index < 3"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="doctor-obligation f_s_c">
        <div
          class="obligation-box"
          v-for="(item, index) in obligation"
          :key="index"
        >
          <img src="../../../static/img/icon-yes@2x.png" alt="" />
          <div class="obligation-desc font-65">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="order-list-box" v-if="order_detail">
      <div class="order-list f_s_s">
        <div class="order-list-left">就诊人</div>
        <div class="order-list-right">{{ order_detail.username }}</div>
      </div>
      <div class="order-list f_s_s">
        <div class="order-list-left">服务类型</div>
        <div class="order-list-right">{{ order_detail.type | order_type }}</div>
      </div>
      <div class="order-list f_s_s">
        <div class="order-list-left">问诊时间</div>
        <div class="order-list-right">
          {{ order_detail.ctime | parse_time }}
        </div>
      </div>
      <div class="order-list f_s_s">
        <div class="order-list-left">问诊价格</div>
        <div class="order-list-right" style="color: #d4380d">
          {{
            order_detail.charge_amount ? "￥" + order_detail.charge_amount : ""
          }}
        </div>
      </div>
    </div>
    <div class="time-box">
      请在{{ pay_end_time_txt }}内完成支付,超时订单自动取消
    </div>
    <div class="footer f_sb_s">
      <div class="contact f_c_s_w" @click="handleTel">
        <img src="../../../static/icons/customservice@3x.png" alt="" />
        <span class="font-65">客服</span>
      </div>
      <div class="pay-btn" @click="gopay">
        实付：{{
          order_detail.charge_amount ? order_detail.charge_amount : "0.00"
        }}元
      </div>
    </div>
    <div class="mask" v-if="paying"></div>
  </div>
</template>
<script>
import http from "../../request/http";
import { formatDate, getCustomerPhone } from "../../utils/index";
export default {
  data() {
    return {
      order_id: null,
      order_detail: {},
      obligation: ["100%医生本人", "12小时必回", "未回复可退款"],
      pay_end_time_txt: "0分0秒",
      paying:false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.order_id = this.$route.query.id;
    }
    this.getOrderDetail();
  },
  filters: {
    order_type(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "图文问诊";
          break;
        case "2":
          txt = "电话咨询";
          break;
        case "3":
          txt = "视频问诊";
          break;
        default:
          txt = "";
      }
      return txt;
    },
    parse_time(val) {
      return formatDate(val * 1000);
    },
  },
  methods: {
    gopay() {
      this.paying = true;
      http
        .post("/api/wap/order/fupay", {
          order_id: this.order_id,
          currency: "cny",
          channel: "wx_pub",
        })
        .then((res) => {
          if (res.errno == 0) {
            let pingpp = require("pingpp-js");
            pingpp.createPayment(res.data, (result, err) => {
              if (result == "success") {
                // 只有微信公众账号 (wx_pub)、微信小程序 (wx_lite)、QQ 公众号 (qpay_pub)、支付宝口碑 (alipay_qr)
                // 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
                this.paying = false;
                this.$toast.center("支付成功");
                this.$router.push("/my_issue");
              } else if (result == "fail") {
                // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
                this.$toast.center("支付异常，请重试");
                this.paying = false;
              } else if (result == "cancel") {
                // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
                this.$toast.center("取消支付");
                this.paying = false;
              }
            });
          } else {
            this.paying = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.paying = false;
        });
    },
    count_down() {
      let nowtime = new Date().getTime();
      let endtime = this.order_detail.ctime * 1000 + 15 * 60 * 1000;
      let lefttime = parseInt((endtime - nowtime) / 1000);
      if (lefttime <= 0) {
        if (this.timerOut) {
          clearTimeout(this.timerOut);
          this.timerOut = null;
        }
        return;
      }
      let m = parseInt((lefttime / 60) % 60);
      let s = parseInt(lefttime % 60);
      m = this.addZero(m);
      s = this.addZero(s);
      this.pay_end_time_txt = `${m}分${s}秒`;
      this.timerOut = setTimeout(this.count_down, 1000);
    },
    addZero(i) {
      return i < 10 ? "0" + i : i + "";
    },
    getOrderDetail() {
      let data = {
        order_id: this.order_id,
      };
      http.post("/api/wap/order/fuinfo", data).then((res) => {
        if (res.data.label) {
          res.data.label_list = res.data.label.split(",");
        }
        this.order_detail = res.data;
        this.count_down();
      });
    },
    handleTel() {
      if (this.$cookies.get("customer_phone")) {
        window.location.href = `tel:${this.$cookies.get("customer_phone")}`;
      } else {
        getCustomerPhone(this, (phone) => {
          window.location.href = `tel:${phone}`;
        });
      }
    },
  },
};
</script>
<style scoped>
.second-pay-container {
  width: 100%;
  height: 100vh;
  background: #fafafa;
}
.title {
  width: 100%;
  height: 5.75rem;
  padding-top: 0.8rem;
  background: #1890ff;
  text-align: center;
  font-size: 0.7rem;
  color: #fff;
  letter-spacing: 0.1rem;
}
.f_c_s,
.f_s_s,
.f_s_c,
.f_c_s_w,
.f_c_c,
.f_sb_s {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.f_sb_s {
  justify-content: space-between;
}
.f_s_s {
  justify-content: flex-start;
}
.f_s_c {
  justify-content: flex-start;
  align-items: center;
}
.f_c_c {
  align-items: center;
}
.f_c_s_w {
  flex-wrap: wrap;
}
.doctor-info {
  width: 100%;
  padding: 1rem 0 0.35rem;
  margin-top: -3.25rem;
  background: #fff;
  position: relative;
  z-index: 10;
}
.doctor-detail {
  width: 100%;
  padding: 0 1rem;
}
.doctor-detail img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  margin-right: 0.5rem;
  vertical-align: top;
  margin-top: 0.2rem;
}
.doctor-detail-right {
  flex-grow: 1;
}
.doctor-name,
.doctor-job {
  width: 100%;
  height: 1.5rem;
  line-height: 1.5rem;
  font-size: 1.1rem;
  font-weight: 500;
}
.doctor-job {
  margin: 0.1rem 0 0.45rem 0;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.45);
}
.doctor-tag {
  display: inline-block;
  height: 1rem;
  line-height: 1rem;
  background: #ffc53d;
  color: #fff;
  text-align: center;
  padding: 0 0.35rem;
  border-radius: 0.15rem;
  font-size: 0.6rem;
}
.doctor-tag + .doctor-tag {
  margin-left: 0.4rem;
}
.doctor-service {
  width: 100%;
  background: #eef6fd;
  height: 2rem;
}
.doctor-obligation {
  width: 100%;
  height: 1.5rem;
  background: #edf6ff;
  padding: 0 1.25rem 0 1.3rem;
}
.obligation-box {
  flex-grow: 1;
  text-align: left;
  height: 0.85rem;
  font-size: 0.6rem;
}
.obligation-box img {
  width: 0.6rem;
  height: 0.6rem;
  vertical-align: middle;
  margin-right: 0.35rem;
}
.obligation-desc {
  display: inline-block;
  height: 0.85rem;
  line-height: 0.85rem;
}
.obligation-box + .obligation-box {
  text-align: center;
}
.obligation-box:last-child {
  text-align: right;
}
.order-list-box {
  width: 100%;
  padding: 0.6rem 1rem 0.7rem;
  margin-top: 0.5rem;
  background: #fff;
}
.order-list-left,
.order-list-right {
  width: auto;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: left;
  color: #8c8c8c;
  font-size: 0.8rem;
}
.order-list-right {
  flex-grow: 1;
  text-align: right;
  color: #262626;
}
.time-box {
  width: 100vw;
  height: 2.2rem;
  line-height: 2.2rem;
  color: #d48806;
  background: #fff6e7;
  text-align: center;
  position: fixed;
  bottom: 2.8rem;
  left: 0;
  font-size: 0.6rem;
}
.footer {
  width: 100%;
  height: 2.8rem;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  padding: 0.3rem 1rem 0.3rem 1.75rem;
}
.contact {
  width: 1.8rem;
  height: 100%;
}
.contact img {
  width: 1rem;
  height: 1rem;
  vertical-align: top;
  margin: 0.1rem 0 0 0.1rem;
}
.contact span {
  display: block;
  height: 1rem;
  width: 100%;
  text-align: center;
  line-height: 1rem;
  font-size: 0.6rem;
}
.pay-btn {
  width: 12.5rem;
  height: 2.2rem;
  font-size: 0.8rem;
  color: #fff;
  background: linear-gradient(180deg, #43a5ff 0%, #4890ff 100%);
  box-shadow: 0px 0.2rem 0.2rem 0px rgba(24, 124, 255, 0.23);
  border-radius: 1.15rem;
  border: none;
  line-height: 2.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/second_pay.vue